module.exports = __webpack_public_path__ + "static/media/Chequebook.69ccce53.svg";